//@flow

import {
  updateConversationApi,
  endpoints as ConversationEndpoint,
} from '../api/conversation';
import {buildRoute} from '../../../../http';

import type {Conversation} from '../../../../entities';
import {conversationAdapter} from '../utils/conversation-adapter';

export async function setConversationCollaboratorService(
  conversationId: string,
  collaboratorId: string
): Promise<Conversation> {
  const route = buildRoute(ConversationEndpoint.UPDATE_CONVERSATION, [
    conversationId,
  ]);

  const [, genericUserId] = collaboratorId.split('-');

  return updateConversationApi(
    {
      userId: `U-${genericUserId}`,
      userType: 'COLLABORATOR',
    },
    {route}
  )
    .toPromise()
    .then(conversation => {
      return conversationAdapter(conversation);
    });
}

export async function assignMeConversationService(
  conversationId: string,
  userId: string
): Promise<Conversation> {
  const route = buildRoute(ConversationEndpoint.UPDATE_CONVERSATION, [
    conversationId,
  ]);

  const [, genericUserId] = userId.split('-');

  return updateConversationApi(
    {
      userId: `U-${genericUserId}`,
      userType: 'VENDOR',
    },
    {route}
  )
    .toPromise()
    .then(conversation => {
      return conversationAdapter(conversation);
    });
}

export async function clearAssignmentConversationService(
  conversationId: string
): Promise<Conversation> {
  const route = buildRoute(ConversationEndpoint.UPDATE_CONVERSATION, [
    conversationId,
  ]);
  return updateConversationApi({userId: ''}, {route})
    .toPromise()
    .then(conversation => {
      return conversationAdapter(conversation);
    });
}
